import DirectDeposit from "@/assets/svg/creator-shield/bank.svg";
import Crypto from "@/assets/svg/creator-shield/crypto.svg";
import MailedCheck from "@/assets/svg/creator-shield/email.svg";
import PayPal from "@/assets/svg/creator-shield/paypal.svg";
import Facebook from "@/assets/svg/creator-shield/social-media/facebook.svg";
import Instagram from "@/assets/svg/creator-shield/social-media/instagram.svg";
import Tiktok from "@/assets/svg/creator-shield/social-media/tiktok.svg";
import Twitch from "@/assets/svg/creator-shield/social-media/twitch.svg";
import YouTube from "@/assets/svg/creator-shield/social-media/youtube.svg";
import WireTransfer from "@/assets/svg/creator-shield/wire-transfer.svg";
import Wise from "@/assets/svg/creator-shield/wise.svg";
import { useLocation } from "react-router-dom";

export default function FullFinancialControl() {
  const location = useLocation();
  const isLivePage = location.pathname.includes("/live");
  const accentColor = isLivePage ? "#9146FF" : "#FF6B35";

  const paymentMethods = [
    {
      name: "Crypto",
      icon: Crypto,
    },
    {
      name: "Mailed Check",
      icon: MailedCheck,
    },
    {
      name: "Direct Deposit",
      icon: DirectDeposit,
    },
    {
      name: "PayPal",
      icon: PayPal,
    },
    {
      name: "Wise",
      icon: Wise,
    },
    {
      name: "Wire Transfer",
      icon: WireTransfer,
    },
  ];

  const platforms = [
    {
      name: "Facebook",
      icon: Facebook,
    },
    {
      name: "YouTube Live",
      icon: YouTube,
    },
    {
      name: "Instagram Reels",
      icon: Instagram,
    },
    {
      name: "Twitch",
      icon: Twitch,
    },
    {
      name: "TikTok",
      icon: Tiktok,
    },
  ];

  const items = isLivePage ? platforms : paymentMethods;
  const headerText = isLivePage
    ? "PLATFORM COVERAGE"
    : "FULL FINANCIAL CONTROL";
  const titlePart1 = isLivePage ? "All Major" : "Get Paid in";
  const titlePart2 = isLivePage
    ? "Livestreaming Platforms"
    : "12+ Different Ways";
  const description = isLivePage ? (
    "Comprehensive protection across every platform where you stream and create."
  ) : (
    <>
      Choose your preferred payment method and get paid in your,
      <br />
      currency your way.
    </>
  );

  return (
    <div id="platform-coverage" className="bg-white h-[800px] lg:h-[610px] py-20 px-6 md:px-16">
      <div className="4xl:max-w-[100rem] 4xl:mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 justify-between items-center gap-12 lg:gap-16">
          {/* Left Side - Text Content */}
          <div className="flex flex-col gap-8 text-center lg:text-left">
            <p
              className="font-semibold text-xl uppercase tracking-wide"
              style={{ color: accentColor }}
            >
              {headerText}
            </p>
            <div className="flex flex-col gap-0">
              <h2 className="text-5xl md:text-6xl lg:text-[50px] xl:text-7xl font-semibold text-black">
                {titlePart1}
              </h2>
              <h2
                className="text-5xl md:text-6xl lg:text-[50px] xl:text-7xl 2xl:text-7xl 1xl:text-7xl font-semibold"
                style={{ color: accentColor }}
              >
                {titlePart2}
              </h2>
            </div>
            <p className="text-lg lg:text-xl text-black font-normal lg:w-[450px] xl:w-[650px] 2xl:w-[900px] 1xl:w-[900px]">
              {description}
            </p>
          </div>

          {/* Right Side - Payment Methods / Platforms */}
          <div className="relative h-[300px] lg:h-[300px] xl:h-[450px] 2xl:h-[500px] overflow-hidden w-full lg:w-[400px] xl:w-[450px] 2xl:w-[500px] 1xl:w-[500px] ml-auto">
            {isLivePage ? (
              <div className="scroll-wrapper-vertical">
                <div className="scroll-track-vertical">
                  {[...Array(2)].map((_, dup) => (
                    <div key={dup}>
                      {items.map((item, index) => {
                        const IconSrc = item.icon;
                        return (
                          <div
                            key={index}
                            className="bg-white border border-[#ddd] rounded-[20px] h-[90px] flex items-center relative mb-[26px]"
                          >
                            {/* Icon Container */}
                            <div className="absolute left-[24.5px] w-[85px] h-[85px] rounded-[10px] flex items-center justify-center overflow-hidden">
                              <img
                                src={IconSrc}
                                alt=""
                                className="w-[50px] h-[50px]"
                              />
                            </div>

                            {/* Text */}
                            <p className="absolute left-[121.5px] text-2xl lg:text-3xl font-semibold text-black">
                              {item.name}
                            </p>
                          </div>
                        );
                      })}
                    </div>
                  ))}
                </div>
              </div>
            ) : (
              <div className="scroll-wrapper-vertical">
                <div className="scroll-track-vertical">
                  {[...Array(2)].map((_, dup) => (
                    <div key={dup}>
                      {items.map((item, index) => {
                        const IconSrc = item.icon;
                        return (
                          <div
                            key={index}
                            className="bg-white border border-[#ddd] rounded-[20px] h-[90px] flex items-center relative mb-[26px]"
                          >
                            {/* Icon Container */}
                            <div className="absolute left-[24.5px] w-[85px] h-[85px] rounded-[10px] flex items-center justify-center overflow-hidden">
                              <img
                                src={IconSrc}
                                alt=""
                                className="w-[50px] h-[50px]"
                              />
                            </div>

                            {/* Text */}
                            <p className="absolute left-[121.5px] text-2xl lg:text-3xl font-semibold text-black">
                              {item.name}
                            </p>
                          </div>
                        );
                      })}
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
